import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaSchool, FaUserGraduate, FaChalkboardTeacher, FaTrophy, FaFemale } from "react-icons/fa";
import './statistics.css'

function Statistics() {
  const [schools, setSchools] = useState(0);
  const [students, setStudents] = useState(0);
  const [teachers, setTeachers] = useState(0);
  const [competitions, setCompetitions] = useState(0);
  const [women, setWomen] = useState(0);
  const [hasScrolledToStats, setHasScrolledToStats] = useState(false); // State to track if the section is in view

  const statsRef = useRef(null); // Ref for the statistics section

  // Function to animate the numbers
  const animateCounter = (target, setState) => {
    let count = 0;
    const increment = Math.ceil(target / 100); // Adjustable increment step (smaller for slower animation)
    const interval = setInterval(() => {
      if (count < target) {
        count += increment; // Increment by the calculated step
        if (count > target) count = target; // Ensure we don't exceed the target
        setState(count);
      } else {
        clearInterval(interval);
      }
    }, 30); // Interval speed (adjustable)
  };

  // Intersection Observer to detect when the stats section comes into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasScrolledToStats) {
          setHasScrolledToStats(true); // Mark that the section has come into view
        }
      },
      { threshold: 0.5 } // Trigger when 50% of the section is in the viewport
    );

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, [hasScrolledToStats]);

  useEffect(() => {
    if (hasScrolledToStats) {
      animateCounter(15, setSchools);
      animateCounter(1850, setStudents);
      animateCounter(50, setTeachers);
      animateCounter(4, setCompetitions);
      animateCounter(200, setWomen);
    }
  }, [hasScrolledToStats]); // Trigger animation only after the stats section is in view

  return (
    <>
      <h2 className="text-center mb-5" style={{ fontSize: "2rem", fontWeight: "700", color: "#002147" }}>
        Our Achievements
      </h2>
      <Container className="statistics-container py-5" ref={statsRef}>
        <Row className="text-center">
          <Col sm={6} md={2} className="stat-item mb-4">
            <div className="stat-icon">
              <FaSchool size={50} color="#FF6347" />
            </div>
            <h3 className="stat-number">{schools}</h3>
            <p className="stat-text">Schools Covered</p>
          </Col>
          <Col sm={6} md={2} className="stat-item mb-4">
            <div className="stat-icon">
              <FaUserGraduate size={50} color="#FFA500" />
            </div>
            <h3 className="stat-number">{students}</h3>
            <p className="stat-text">Students</p>
          </Col>
          <Col sm={6} md={2} className="stat-item mb-4">
            <div className="stat-icon">
              <FaChalkboardTeacher size={50} color="#32CD32" />
            </div>
            <h3 className="stat-number">{teachers}</h3>
            <p className="stat-text">Teachers Awarded</p>
          </Col>
          <Col sm={6} md={2} className="stat-item mb-4">
            <div className="stat-icon">
              <FaTrophy size={50} color="#1E90FF" />
            </div>
            <h3 className="stat-number">{competitions}</h3>
            <p className="stat-text">Competitions</p>
          </Col>
          <Col sm={6} md={2} className="stat-item mb-4">
            <div className="stat-icon">
              <FaFemale size={50} color="#800080" />
            </div>
            <h3 className="stat-number">{women}</h3>
            <p className="stat-text">Women Got Exposure</p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Statistics;
